module.exports = __webpack_public_path__ + "img/rounded-reroll-hover.ce02a8d8.svg";